module.exports = __webpack_public_path__ + "static/media/ChannelIcon.aab8fba9.svg";